import React, { useState } from 'react'
import { graphql, Link } from 'gatsby'
import GraphQLErrorList from '../../components/graphql-error-list'
import SEO from '../../components/seo'
import Layout from '../../containers/layout'
import Container from '../../components/container'
import CloudIndexNav from '../../components/cloudIndexNav/cloudIndexNav'
import CloudIndexTable from '../../components/cloudIndexTable/cloudIndexTable'
import { Accordion } from '../../components/accordion/accordion'

import infraLogo from '../../img/InfraRed100.svg'

import oven from '../../img/logos/oven-logo/oven-logo.png'
import ovenHover from '../../img/logos/oven-logo/oven-logo-hover.png'
import dremio from '../../img/logos/dremio-logo/dremio-logo.png'
import dremioHover from '../../img/logos/dremio-logo/dremio-logo-hover.png'
import soloio from '../../img/logos/soloio-logo/soloio-logo.png'
import soloioHover from '../../img/logos/soloio-logo/soloio-logo-hover.png'
import appomni from '../../img/logos/appomni-logo/appomni-logo.png'
import appomniHover from '../../img/logos/appomni-logo/appomni-logo-hover.png'
import dataiku from '../../img/logos/dataiku-logo/dataiku-logo.png'
import dataikuHover from '../../img/logos/dataiku-logo/dataiku-logo-hover.png'
import pinecone from '../../img/logos/pinecone-logo/pinecone-logo.png'
import pineconeHover from '../../img/logos/pinecone-logo/pinecone-logo-hover.png'
import redpandadata from '../../img/logos/redpandadata-logo/redpandadata-logo.png'
import redpandadataHover from '../../img/logos/redpandadata-logo/redpandadata-logo-hover.png'
import sigma from '../../img/logos/sigma-logo/sigma-logo.png'
import sigmaHover from '../../img/logos/sigma-logo/sigma-logo-hover.png'
import fireblocks from '../../img/logos/fireblocks-logo/fireblocks-logo.png'
import fireblocksHover from '../../img/logos/fireblocks-logo/fireblocks-logo-hover.png'
import replicated from '../../img/logos/replicated-logo/replicated-logo.png'
import replicatedHover from '../../img/logos/replicated-logo/replicated-logo-hover.png'
import montecarlo from '../../img/logos/montecarlo-logo/montecarlo-logo.png'
import montecarloHover from '../../img/logos/montecarlo-logo/montecarlo-logo-hover.png'
import collibra from '../../img/logos/collibra-logo/collibra-logo.png'
import collibraHover from '../../img/logos/collibra-logo/collibra-logo-hover.png'
import onepassword from '../../img/logos/onepassword-logo/onepassword-logo.png'
import onepasswordHover from '../../img/logos/onepassword-logo/onepassword-logo-hover.png'
import minio from '../../img/logos/minio-logo/minio-logo.png'
import minioHover from '../../img/logos/minio-logo/minio-logo-hover.png'
import lumos from '../../img/logos/lumos-logo/lumos-logo.png'
import lumosHover from '../../img/logos/lumos-logo/lumos-logo-hover.png'
import axonius from '../../img/logos/axonius-logo/axonius-logo.png'
import axoniusHover from '../../img/logos/axonius-logo/axonius-logo-hover.png'
import deno from '../../img/logos/deno-logo/deno-logo.png'
import denoHover from '../../img/logos/deno-logo/deno-logo-hover.png'
import planetscale from '../../img/logos/planetscale-logo/planetscale-logo.png'
import planetscaleHover from '../../img/logos/planetscale-logo/planetscale-logo-hover.png'
import airplane from '../../img/logos/airplane-logo/airplane-logo.png'
import airplaneHover from '../../img/logos/airplane-logo/airplane-logo-hover.png'
import pulumi from '../../img/logos/pulumi-logo/pulumi-logo.png'
import pulumiHover from '../../img/logos/pulumi-logo/pulumi-logo-hover.png'
import incidentio from '../../img/logos/incidentio-logo/incidentio-logo.png'
import incidentioHover from '../../img/logos/incidentio-logo/incidentio-logo-hover.png'
import isovalent from '../../img/logos/isovalent-logo/isovalent-logo.png'
import isovalentHover from '../../img/logos/isovalent-logo/isovalent-logo-hover.png'
import dragonflydb from '../../img/logos/dragonflydb-logo/dragonflydb-logo.png'
import dragonflydbHover from '../../img/logos/dragonflydb-logo/dragonflydb-logo-hover.png'
import kubecost from '../../img/logos/kubecost-logo/kubecost-logo.png'
import kubecostHover from '../../img/logos/kubecost-logo/kubecost-logo-hover.png'
import hightouch from '../../img/logos/hightouch-logo/hightouch-logo.png'
import hightouchHover from '../../img/logos/hightouch-logo/hightouch-logo-hover.png'
import humansignal from '../../img/logos/humansignal-logo/humansignal-logo.png'
import humansignalHover from '../../img/logos/humansignal-logo/humansignal-logo-hover.png'
import tackleio from '../../img/logos/tackleio-logo/tackleio-logo.png'
import tackleioHover from '../../img/logos/tackleio-logo/tackleio-logo-hover.png'
import replicate from '../../img/logos/replicate-logo/replicate-logo.png'
import replicateHover from '../../img/logos/replicate-logo/replicate-logo-hover.png'
import conductorone from '../../img/logos/conductorone-logo/conductorone-logo.png'
import conductoroneHover from '../../img/logos/conductorone-logo/conductorone-logo-hover.png'
import drata from '../../img/logos/drata-logo/drata-logo.png'
import drataHover from '../../img/logos/drata-logo/drata-logo-hover.png'
import startree from '../../img/logos/startree-logo/startree-logo.png'
import startreeHover from '../../img/logos/startree-logo/startree-logo-hover.png'
import assemblyai from '../../img/logos/assemblyai-logo/assemblyai-logo.png'
import assemblyaiHover from '../../img/logos/assemblyai-logo/assemblyai-logo-hover.png'
import singlestore from '../../img/logos/singlestore-logo/singlestore-logo.png'
import singlestoreHover from '../../img/logos/singlestore-logo/singlestore-logo-hover.png'
import chromatic from '../../img/logos/chromatic-logo/chromatic-logo.png'
import chromaticHover from '../../img/logos/chromatic-logo/chromatic-logo-hover.png'
import retool from '../../img/logos/retool-logo/retool-logo.png'
import retoolHover from '../../img/logos/retool-logo/retool-logo-hover.png'
import synthesia from '../../img/logos/synthesia-logo/synthesia-logo.png'
import synthesiaHover from '../../img/logos/synthesia-logo/synthesia-logo-hover.png'
import scaleai from '../../img/logos/scaleai-logo/scaleai-logo.png'
import scaleaiHover from '../../img/logos/scaleai-logo/scaleai-logo-hover.png'
import tabular from '../../img/logos/tabular-logo/tabular-logo.png'
import tabularHover from '../../img/logos/tabular-logo/tabular-logo-hover.png'
import doppler from '../../img/logos/doppler-logo/doppler-logo.png'
import dopplerHover from '../../img/logos/doppler-logo/doppler-logo-hover.png'
import runzero from '../../img/logos/runzero-logo/runzero-logo.png'
import runzeroHover from '../../img/logos/runzero-logo/runzero-logo-hover.png'
import livekit from '../../img/logos/livekit-logo/livekit-logo.png'
import livekitHover from '../../img/logos/livekit-logo/livekit-logo-hover.png'
import dagger from '../../img/logos/dagger-logo/dagger-logo.png'
import daggerHover from '../../img/logos/dagger-logo/dagger-logo-hover.png'
import flyio from '../../img/logos/flyio-logo/flyio-logo.png'
import flyioHover from '../../img/logos/flyio-logo/flyio-logo-hover.png'
import jellyfish from '../../img/logos/jellyfish-logo/jellyfish-logo.png'
import jellyfishHover from '../../img/logos/jellyfish-logo/jellyfish-logo-hover.png'
import fivetran from '../../img/logos/fivetran-logo/fivetran-logo.png'
import fivetranHover from '../../img/logos/fivetran-logo/fivetran-logo-hover.png'
import chronosphere from '../../img/logos/chronosphere-logo/chronosphere-logo.png'
import chronosphereHover from '../../img/logos/chronosphere-logo/chronosphere-logo-hover.png'
import buildbuddy from '../../img/logos/buildbuddy-logo/buildbuddy-logo.png'
import buildbuddyHover from '../../img/logos/buildbuddy-logo/buildbuddy-logo-hover.png'
import grafanalabs from '../../img/logos/grafanalabs-logo/grafanalabs-logo.png'
import grafanalabsHover from '../../img/logos/grafanalabs-logo/grafanalabs-logo-hover.png'
import projectdiscoveryio from '../../img/logos/projectdiscoveryio-logo/projectdiscoveryio-logo.png'
import projectdiscoveryioHover from '../../img/logos/projectdiscoveryio-logo/projectdiscoveryio-logo-hover.png'
import glean from '../../img/logos/glean-logo/glean-logo.png'
import gleanHover from '../../img/logos/glean-logo/glean-logo-hover.png'
import starburst from '../../img/logos/starburst-logo/starburst-logo.png'
import starburstHover from '../../img/logos/starburst-logo/starburst-logo-hover.png'
import autogpt from '../../img/logos/autogpt-logo/autogpt-logo.png'
import autogptHover from '../../img/logos/autogpt-logo/autogpt-logo-hover.png'
import materialize from '../../img/logos/materialize-logo/materialize-logo.png'
import materializeHover from '../../img/logos/materialize-logo/materialize-logo-hover.png'
import cortex from '../../img/logos/cortex-logo/cortex-logo.png'
import cortexHover from '../../img/logos/cortex-logo/cortex-logo-hover.png'
import timescale from '../../img/logos/timescale-logo/timescale-logo-v2.png'
import timescaleHover from '../../img/logos/timescale-logo/timescale-logo-hover-v2.png'
import reflex from '../../img/logos/reflex-logo/reflex-logo.png'
import reflexHover from '../../img/logos/reflex-logo/reflex-logo-hover.png'
import warpstream from '../../img/logos/warpstream-logo/warpstream-logo.png'
import warpstreamHover from '../../img/logos/warpstream-logo/warpstream-logo-hover.png'
import llamaindex from '../../img/logos/llamaindex-logo/llamaindex-logo.png'
import llamaindexHover from '../../img/logos/llamaindex-logo/llamaindex-logo-hover.png'
import magic from '../../img/logos/magic-logo/magic-logo.png'
import magicHover from '../../img/logos/magic-logo/magic-logo-hover.png'
import straiker from '../../img/logos/straiker-logo/straiker-logo.png'
import straikerHover from '../../img/logos/straiker-logo/straiker-logo-hover.png'
import ollama from '../../img/logos/ollama-logo/ollama-logo.png'
import ollamaHover from '../../img/logos/ollama-logo/ollama-logo-hover.png'
import resend from '../../img/logos/resend-logo/resend-logo.png'
import resendHover from '../../img/logos/resend-logo/resend-logo-hover.png'
import patronusai from '../../img/logos/patronusai-logo/patronusai-logo.png'
import patronusaiHover from '../../img/logos/patronusai-logo/patronusai-logo-hover.png'
import coreweave from '../../img/logos/coreweave-logo/coreweave-logo.png'
import coreweaveHover from '../../img/logos/coreweave-logo/coreweave-logo-hover.png'
import modular from '../../img/logos/modular-logo/modular-logo.png'
import modularHover from '../../img/logos/modular-logo/modular-logo-hover.png'
import lancedb from '../../img/logos/lancedb-logo/lancedb-logo.png'
import lancedbHover from '../../img/logos/lancedb-logo/lancedb-logo-hover.png'
import cerby from '../../img/logos/cerby-logo/cerby-logo.png'
import cerbyHover from '../../img/logos/cerby-logo/cerby-logo-hover.png'
import oasis from '../../img/logos/oasis-logo/oasis-logo.png'
import oasisHover from '../../img/logos/oasis-logo/oasis-logo-hover.png'
import momento from '../../img/logos/momento-logo/momento-logo.png'
import momentoHover from '../../img/logos/momento-logo/momento-logo-hover.png'
import weightsbiases from '../../img/logos/weightsbiases-logo/weightsbiases-logo.png'
import weightsbiasesHover from '../../img/logos/weightsbiases-logo/weightsbiases-logo-hover.png'
import vantage from '../../img/logos/vantage-logo/vantage-logo.png'
import vantageHover from '../../img/logos/vantage-logo/vantage-logo-hover.png'
import tines from '../../img/logos/tines-logo/tines-logo.png'
import tinesHover from '../../img/logos/tines-logo/tines-logo-hover.png'
import clerk from '../../img/logos/clerk-logo/clerk-logo.png'
import clerkHover from '../../img/logos/clerk-logo/clerk-logo-hover.png'
import localstack from '../../img/logos/localstack-logo/localstack-logo.png'
import localstackHover from '../../img/logos/localstack-logo/localstack-logo-hover.png'
import flutterflow from '../../img/logos/flutterflow-logo/flutterflow-logo.png'
import flutterflowHover from '../../img/logos/flutterflow-logo/flutterflow-logo-hover.png'
import zesty from '../../img/logos/zesty-logo/zesty-logo.png'
import zestyHover from '../../img/logos/zesty-logo/zesty-logo-hover.png'
import normai from '../../img/logos/normai-logo/normai-logo.png'
import normaiHover from '../../img/logos/normai-logo/normai-logo-hover.png'
import nagomi from '../../img/logos/nagomi-logo/nagomi-logo.png'
import nagomiHover from '../../img/logos/nagomi-logo/nagomi-logo-hover.png'
import wiz from '../../img/logos/wiz-logo/wiz-logo.png'
import wizHover from '../../img/logos/wiz-logo/wiz-logo-hover.png'
import codium from '../../img/logos/codium-logo/codium-logo.png'
import codiumHover from '../../img/logos/codium-logo/codium-logo-hover.png'
import tigerbeetle from '../../img/logos/tigerbeetle-logo/tigerbeetle-logo.png'
import tigerbeetleHover from '../../img/logos/tigerbeetle-logo/tigerbeetle-logo-hover.png'
import weaviate from '../../img/logos/weaviate-logo/weaviate-logo.png'
import weaviateHover from '../../img/logos/weaviate-logo/weaviate-logo-hover.png'

import harness from '../../img/logos/harness-logo/harness-logo.png'
import harnessHover from '../../img/logos/harness-logo/harness-logo-hover.png'
import hex from '../../img/logos/hex-logo/hex-logo.png'
import hexHover from '../../img/logos/hex-logo/hex-logo-hover.png'
import huggingface from '../../img/logos/hugging-face-logo/hugging-face-logo.png'
import huggingfaceHover from '../../img/logos/hugging-face-logo/hugging-face-logo-hover.png'
import island from '../../img/logos/island-logo/island-logo.png'
import islandHover from '../../img/logos/island-logo/island-logo-hover.png'
import langchain from '../../img/logos/langchain-logo/langchain-logo.png'
import langchainHover from '../../img/logos/langchain-logo/langchain-logo-hover.png'
import launchdarkly from '../../img/logos/launchdarkly-logo/launchdarkly-logo.png'
import launchdarklyHover from '../../img/logos/launchdarkly-logo/launchdarkly-logo-hover.png'
import linear from '../../img/logos/linear-logo/linear-logo.png'
import linearHover from '../../img/logos/linear-logo/linear-logo-hover.png'
import metronome from '../../img/logos/metronome-logo/metronome-logo.png'
import metronomeHover from '../../img/logos/metronome-logo/metronome-logo-hover.png'
import mistralai from '../../img/logos/mistral-ai-logo/mistral-ai-logo.png'
import mistralaiHover from '../../img/logos/mistral-ai-logo/mistral-ai-logo-hover.png'
import modal from '../../img/logos/modal-logo/modal-logo.png'
import modalHover from '../../img/logos/modal-logo/modal-logo-hover.png'
import motherduck from '../../img/logos/motherduck-logo/motherduck-logo.png'
import motherduckHover from '../../img/logos/motherduck-logo/motherduck-logo-hover.png'
import neon from '../../img/logos/neon-logo/neon-logo.png'
import neonHover from '../../img/logos/neon-logo/neon-logo-hover.png'
import omni from '../../img/logos/omni-logo/omni-logo.png'
import omniHover from '../../img/logos/omni-logo/omni-logo-hover.png'
import openai from '../../img/logos/openai-logo/openai-logo.png'
import openaiHover from '../../img/logos/openai-logo/openai-logo-hover.png'
import orcasecurity from '../../img/logos/orca-security-logo/orca-security-logo.png'
import orcasecurityHover from '../../img/logos/orca-security-logo/orca-security-logo-hover.png'
import poolside from '../../img/logos/poolside-logo/poolside-logo.png'
import poolsideHover from '../../img/logos/poolside-logo/poolside-logo-hover.png'
import postman from '../../img/logos/postman-logo/postman-logo.png'
import postmanHover from '../../img/logos/postman-logo/postman-logo-hover.png'
import railway from '../../img/logos/railway-logo/railway-logo.png'
import railwayHover from '../../img/logos/railway-logo/railway-logo-hover.png'
import redis from '../../img/logos/redis-logo/redis-logo.png'
import redisHover from '../../img/logos/redis-logo/redis-logo-hover.png'
import replit from '../../img/logos/replit-logo/replit-logo.png'
import replitHover from '../../img/logos/replit-logo/replit-logo-hover.png'
import restate from '../../img/logos/restate-logo/restate-logo.png'
import restateHover from '../../img/logos/restate-logo/restate-logo-hover.png'
import semgrep from '../../img/logos/semgrep-logo/semgrep-logo.png'
import semgrepHover from '../../img/logos/semgrep-logo/semgrep-logo-hover.png'
import snyk from '../../img/logos/snyk-logo/snyk-logo.png'
import snykHover from '../../img/logos/snyk-logo/snyk-logo-hover.png'
import sourcegraph from '../../img/logos/sourcegraph-logo/sourcegraph-logo.png'
import sourcegraphHover from '../../img/logos/sourcegraph-logo/sourcegraph-logo-hover.png'
import stripe from '../../img/logos/stripe-logo/stripe-logo.png'
import stripeHover from '../../img/logos/stripe-logo/stripe-logo-hover.png'
import sublimesecurity from '../../img/logos/sublime-security-logo/sublime-security-logo.png'
import sublimesecurityHover from '../../img/logos/sublime-security-logo/sublime-security-logo-hover.png'
import supabase from '../../img/logos/supabase-logo/supabase-logo.png'
import supabaseHover from '../../img/logos/supabase-logo/supabase-logo-hover.png'
import surrealdb from '../../img/logos/surrealdb-logo/surrealdb-logo.png'
import surrealdbHover from '../../img/logos/surrealdb-logo/surrealdb-logo-hover.png'
import tailscale from '../../img/logos/tailscale-logo/tailscale-logo.png'
import tailscaleHover from '../../img/logos/tailscale-logo/tailscale-logo-hover.png'
import temporal from '../../img/logos/temporal-logo/temporal-logo.png'
import temporalHover from '../../img/logos/temporal-logo/temporal-logo-hover.png'
import tessell from '../../img/logos/tessell-logo/tessell-logo.png'
import tessellHover from '../../img/logos/tessell-logo/tessell-logo-hover.png'
import togetherai from '../../img/logos/together-ai-logo/together-ai-logo.png'
import togetheraiHover from '../../img/logos/together-ai-logo/together-ai-logo-hover.png'
import upwind from '../../img/logos/upwind-logo/upwind-logo.png'
import upwindHover from '../../img/logos/upwind-logo/upwind-logo-hover.png'
import vast from '../../img/logos/vast-logo/vast-logo.png'
import vastHover from '../../img/logos/vast-logo/vast-logo-hover.png'
import vercel from '../../img/logos/vercel-logo/vercel-logo.png'
import vercelHover from '../../img/logos/vercel-logo/vercel-logo-hover.png'
import workato from '../../img/logos/workato-logo/workato-logo.png'
import workatoHover from '../../img/logos/workato-logo/workato-logo-hover.png'
import zedindustries from '../../img/logos/zed-industries-logo/zed-industries-logo.png'
import zedindustriesHover from '../../img/logos/zed-industries-logo/zed-industries-logo-hover.png'
import cyberhaven from '../../img/logos/cyberhaven-logo/cyberhaven-logo.png'
import cyberhavenHover from '../../img/logos/cyberhaven-logo/cyberhaven-logo-hover.png'
import arcticwolf from '../../img/logos/arctic-wolf-logo/arctic-wolf-logo.png'
import arcticwolfHover from '../../img/logos/arctic-wolf-logo/arctic-wolf-logo-hover.png'
import render from '../../img/logos/render-logo/render-logo.png'
import renderHover from '../../img/logos/render-logo/render-logo-hover.png'
import halcyon from '../../img/logos/halcyon-logo/halcyon-logo.png'
import halcyonHover from '../../img/logos/halcyon-logo/halcyon-logo-hover.png'
import scale from '../../img/logos/scale-logo/scale-logo.png'
import scaleHover from '../../img/logos/scale-logo/scale-logo-hover.png'
import goodfire from '../../img/logos/goodfire-logo/goodfire-logo.png'
import goodfireHover from '../../img/logos/goodfire-logo/goodfire-logo-hover.png'
import braintrust from '../../img/logos/braintrust-logo/braintrust-logo.png'
import braintrustHover from '../../img/logos/braintrust-logo/braintrust-logo-hover.png'
import xbow from '../../img/logos/xbow-logo/xbow-logo.png'
import xbowHover from '../../img/logos/xbow-logo/xbow-logo-hover.png'
import cockroachlabs from '../../img/logos/cockroach-logo/cockroach-logo.png'
import cockroachlabsHover from '../../img/logos/cockroach-logo/cockroach-logo-hover.png'
import anthropic from '../../img/logos/anthropic-logo/anthropic-logo.png'
import anthropicHover from '../../img/logos/anthropic-logo/anthropic-logo-hover.png'
import clickhouse from '../../img/logos/clickhouse-logo/clickhouse-logo.png'
import clickhouseHover from '../../img/logos/clickhouse-logo/clickhouse-logo-hover.png'
import cursor from '../../img/logos/cursor-logo/cursor-logo.png'
import cursorHover from '../../img/logos/cursor-logo/cursor-logo-hover.png'
import cyera from '../../img/logos/cyera-logo/cyera-logo.png'
import cyeraHover from '../../img/logos/cyera-logo/cyera-logo-hover.png'
import gitpod from '../../img/logos/gitpod-logo/gitpod-logo.png'
import gitpodHover from '../../img/logos/gitpod-logo/gitpod-logo-hover.png'
import pointfive from '../../img/logos/pointfive-logo/pointfive-logo.png'
import pointfiveHover from '../../img/logos/pointfive-logo/pointfive-logo-hover.png'
import cohesity from '../../img/logos/cohesity-logo/cohesity-logo.png'
import cohesityHover from '../../img/logos/cohesity-logo/cohesity-logo-hover.png'
import prophet from '../../img/logos/prophet-logo/prophet-logo.png'
import prophetHover from '../../img/logos/prophet-logo/prophet-logo-hover.png'
import dbtlabs from '../../img/logos/dbt-labs-logo/dbt-labs-logo.png'
import dbtlabsHover from '../../img/logos/dbt-labs-logo/dbt-labs-logo-hover.png'
import ai from '../../img/logos/7ai-logo/7ai-logo.png'
import aiHover from '../../img/logos/7ai-logo/7ai-logo-hover.png'
import stackblitz from '../../img/logos/stackblitz-logo/stackblitz-logo.png'
import stackblitzHover from '../../img/logos/stackblitz-logo/stackblitz-logo-hover.png'
import databricks from '../../img/logos/databricks-logo/databricks-logo.png'
import databricksHover from '../../img/logos/databricks-logo/databricks-logo-hover.png'
import flox from '../../img/logos/flox-logo/flox-logo.png'
import floxHover from '../../img/logos/flox-logo/flox-logo-hover.png'
import browserbase from '../../img/logos/browserbase-logo/browserbase-logo.png'
import browserbaseHover from '../../img/logos/browserbase-logo/browserbase-logo-hover.png'
import fal from '../../img/logos/fal-logo/fal-logo.png'
import falHover from '../../img/logos/fal-logo/fal-logo-hover.png'
import traversal from '../../img/logos/traversal-logo/traversal-logo.png'
import traversalHover from '../../img/logos/traversal-logo/traversal-logo-hover.png'
import grofanalabs from '../../img/logos/grofana-labs-logo/grofana-labs-logo.png'
import grofanalabsHover from '../../img/logos/grofana-labs-logo/grofana-labs-logo-hover.png'
import resolveai from '../../img/logos/resolve-ai-logo/resolve-ai-logo.png'
import resolveaiHover from '../../img/logos/resolve-ai-logo/resolve-ai-logo-hover.png'
import docker from '../../img/logos/docker-logo/docker-logo.png'
import dockerHover from '../../img/logos/docker-logo/docker-logo-hover.png'
import astrix from '../../img/logos/astrix-logo/astrix-logo.png'
import astrixHover from '../../img/logos/astrix-logo/astrix-logo-hover.png'
import dragonfly from '../../img/logos/dragonfly-logo/dragonfly-logo.png'
import dragonflyHover from '../../img/logos/dragonfly-logo/dragonfly-logo-hover.png'
import antithesis from '../../img/logos/antithesis-logo/antithesis-logo.png'
import antithesisHover from '../../img/logos/antithesis-logo/antithesis-logo-hover.png'
import atlan from '../../img/logos/atlan-logo/atlan-logo.png'
import atlanHover from '../../img/logos/atlan-logo/atlan-logo-hover.png'
import unsloth from '../../img/logos/unsloth-logo/unsloth-logo.png'
import unslothHover from '../../img/logos/unsloth-logo/unsloth-logo-hover.png'
import abnormal from '../../img/logos/abnormal-logo/abnormal-logo.png'
import abnormalHover from '../../img/logos/abnormal-logo/abnormal-logo-hover.png'
import legion from '../../img/logos/legion-logo/legion-logo.png'
import legionHover from '../../img/logos/legion-logo/legion-logo-hover.png'
import coderabbit from '../../img/logos/coderabbit-logo/coderabbit-logo.png'
import coderabbitHover from '../../img/logos/coderabbit-logo/coderabbit-logo-hover.png'
import adaptive from '../../img/logos/adaptive-logo/adaptive-logo.png'
import adaptiveHover from '../../img/logos/adaptive-logo/adaptive-logo-hover.png'
import port from '../../img/logos/port-logo/port-logo.png'
import portHover from '../../img/logos/port-logo/port-logo-hover.png'
import spiral from '../../img/logos/spiral-logo/spiral-logo.png'
import spiralHover from '../../img/logos/spiral-logo/spiral-logo-hover.png'
import vapi from '../../img/logos/vapi-logo/vapi-logo.png'
import vapiHover from '../../img/logos/vapi-logo/vapi-logo-hover.png'
import cognition from '../../img/logos/cognition-logo/cognition-logo.png'
import cognitionHover from '../../img/logos/cognition-logo/cognition-logo-hover.png'
import chainguard from '../../img/logos/chainguard-logo/chainguard-logo.png'
import chainguardHover from '../../img/logos/chainguard-logo/chainguard-logo-hover.png'
import qawold from '../../img/logos/qa-wold-logo/qa-wold-logo.png'
import qawoldHover from '../../img/logos/qa-wold-logo/qa-wold-logo-hover.png'
import turbopuffer from '../../img/logos/turbopuffer-logo/turbopuffer-logo.png'
import turbopufferHover from '../../img/logos/turbopuffer-logo/turbopuffer-logo-hover.png'
import cribl from '../../img/logos/cribl-logo/cribl-logo.png'
import criblHover from '../../img/logos/cribl-logo/cribl-logo-hover.png'
import licvekit from '../../img/logos/licvekit-logo/licvekit-logo.png'
import licvekitHover from '../../img/logos/licvekit-logo/licvekit-logo-hover.png'
import bitwarden from '../../img/logos/bitwarden-logo/bitwarden-logo.png'
import bitwardenHover from '../../img/logos/bitwarden-logo/bitwarden-logo-hover.png'
import iielevenlabs from '../../img/logos/elevenlabs-logo/elevenlabs-logo.png'
import iielevenlabsHover from '../../img/logos/elevenlabs-logo/elevenlabs-logo-hover.png'
import fireworksai from '../../img/logos/fireworks-ai-logo/fireworks-ai-logo.png'
import fireworksaiHover from '../../img/logos/fireworks-ai-logo/fireworks-ai-logo-hover.png'
import mimic from '../../img/logos/mimic-logo/mimic-logo.png'
import mimicHover from '../../img/logos/mimic-logo/mimic-logo-hover.png'
import baseten from '../../img/logos/baseten-logo/baseten-logo.png'
import basetenHover from '../../img/logos/baseten-logo/baseten-logo-hover.png'
import descope from '../../img/logos/descope-logo/descope-logo.png'
import descopeHover from '../../img/logos/descope-logo/descope-logo-hover.png'
import bitdrift from '../../img/logos/bitdrift-logo/bitdrift-logo.png'
import bitdriftHover from '../../img/logos/bitdrift-logo/bitdrift-logo-hover.png'
import pydantic from '../../img/logos/pydantic-logo/pydantic-logo.png'
import pydanticHover from '../../img/logos/pydantic-logo/pydantic-logo-hover.png'
import lovable from '../../img/logos/lovable-logo/lovable-logo.png'
import lovableHover from '../../img/logos/lovable-logo/lovable-logo-hover.png'
import outtakeai from '../../img/logos/outtake-ai-logo/outtake-ai-logo.png'
import outtakeaiHover from '../../img/logos/outtake-ai-logo/outtake-ai-logo-hover.png'
import stainless from '../../img/logos/stainless-logo/stainless-logo.png'
import stainlessHover from '../../img/logos/stainless-logo/stainless-logo-hover.png'
import windsurf from '../../img/logos/windsurf-logo/windsurf-logo.png'
import windsurfHover from '../../img/logos/windsurf-logo/windsurf-logo-hover.png'
import statsig from '../../img/logos/statsig-logo/statsig-logo.png'
import statsigHover from '../../img/logos/statsig-logo/statsig-logo-hover.png'
import vega from '../../img/logos/vega-logo/vega-logo.png'
import vegaHover from '../../img/logos/vega-logo/vega-logo-hover.png'
import unstructured from '../../img/logos/unstructured-logo/unstructured-logo.png'
import unstructuredHover from '../../img/logos/unstructured-logo/unstructured-logo-hover.png'
import composio from '../../img/logos/composio-logo/composio-logo.png'
import composioHover from '../../img/logos/composio-logo/composio-logo-hover.png'
import reflection from '../../img/logos/reflection-logo/reflection-logo.png'
import reflectionHover from '../../img/logos/reflection-logo/reflection-logo-hover.png'
import bolt from '../../img/logos/bolt-logo/bolt-logo.png'
import boltHover from '../../img/logos/bolt-logo/bolt-logo-hover.png'

import appliedcompute from '../../img/logos/applied-compute-logo/applied-compute-logo.png'
import appliedcomputeHover from '../../img/logos/applied-compute-logo/applied-compute-logo-hover.png'
import armadin from '../../img/logos/armadin-logo/armadin-logo.png'
import armadinHover from '../../img/logos/armadin-logo/armadin-logo-hover.png'
import blacksmith from '../../img/logos/blacksmith-logo/blacksmith-logo.png'
import blacksmithHover from '../../img/logos/blacksmith-logo/blacksmith-logo-hover.png'
import codestorage from '../../img/logos/code-storage-logo/code-storage-logo.png'
import codestorageHover from '../../img/logos/code-storage-logo/code-storage-logo-hover.png'
import codemetal from '../../img/logos/code-metal-logo/code-metal-logo.png'
import codemetalHover from '../../img/logos/code-metal-logo/code-metal-logo-hover.png'
import coder from '../../img/logos/coder-logo/coder-logo.png'
import coderHover from '../../img/logos/coder-logo/coder-logo-hover.png'
import cogentsecurity from '../../img/logos/cogent-security-logo/cogent-security-logo.png'
import cogentsecurityHover from '../../img/logos/cogent-security-logo/cogent-security-logo-hover.png'
import dash0 from '../../img/logos/dash0-logo/dash0-logo.png'
import dash0Hover from '../../img/logos/dash0-logo/dash0-logo-hover.png'
import davidai from '../../img/logos/david-ai-logo/david-ai-logo.png'
import davidaiHover from '../../img/logos/david-ai-logo/david-ai-logo-hover.png'
import daytona from '../../img/logos/daytona-logo/daytona-logo.png'
import daytonaHover from '../../img/logos/daytona-logo/daytona-logo-hover.png'
import deeptune from '../../img/logos/deeptune-logo/deeptune-logo.png'
import deeptuneHover from '../../img/logos/deeptune-logo/deeptune-logo-hover.png'
import depthfirst from '../../img/logos/depthfirst-logo/depthfirst-logo.png'
import depthfirstHover from '../../img/logos/depthfirst-logo/depthfirst-logo-hover.png'
import dux from '../../img/logos/dux-logo/dux-logo.png'
import duxHover from '../../img/logos/dux-logo/dux-logo-hover.png'
import e2b from '../../img/logos/e2b-logo/e2b-logo.png'
import e2bHover from '../../img/logos/e2b-logo/e2b-logo-hover.png'
import emergent from '../../img/logos/emergent-logo/emergent-logo.png'
import emergentHover from '../../img/logos/emergent-logo/emergent-logo-hover.png'
import eon from '../../img/logos/eon-logo/eon-logo.png'
import eonHover from '../../img/logos/eon-logo/eon-logo-hover.png'
import ersc from '../../img/logos/ersc-logo/ersc-logo.png'
import erscHover from '../../img/logos/ersc-logo/ersc-logo-hover.png'
import fable from '../../img/logos/fable-logo/fable-logo.png'
import fableHover from '../../img/logos/fable-logo/fable-logo-hover.png'
import fleet from '../../img/logos/fleet-logo/fleet-logo.png'
import fleetHover from '../../img/logos/fleet-logo/fleet-logo-hover.png'
import gambit from '../../img/logos/gambit-logo/gambit-logo.png'
import gambitHover from '../../img/logos/gambit-logo/gambit-logo-hover.png'
import gimletlabs from '../../img/logos/gimblet-labs-logo/gimblet-labs-logo.png'
import gimletlabsHover from '../../img/logos/gimblet-labs-logo/gimblet-labs-logo-hover.png'
import glow from '../../img/logos/glow-logo/glow-logo.png'
import glowHover from '../../img/logos/glow-logo/glow-logo-hover.png'
import imper from '../../img/logos/imper-logo/imper-logo.png'
import imperHover from '../../img/logos/imper-logo/imper-logo-hover.png'
import inferact from '../../img/logos/inferact-logo/inferact-logo.png'
import inferactHover from '../../img/logos/inferact-logo/inferact-logo-hover.png'
import irregularlabs from '../../img/logos/irregular-labs-logo/irregular-labs-logo.png'
import irregularlabsHover from '../../img/logos/irregular-labs-logo/irregular-labs-logo-hover.png'
import jetstream from '../../img/logos/jetstream-logo/jetstream-logo.png'
import jetstreamHover from '../../img/logos/jetstream-logo/jetstream-logo-hover.png'
import judgmentlabs from '../../img/logos/judgement-labs-logo/judgement-labs-logo.png'
import judgmentlabsHover from '../../img/logos/judgement-labs-logo/judgement-labs-logo-hover.png'
import keycard from '../../img/logos/keycard-logo/keycard-logo.png'
import keycardHover from '../../img/logos/keycard-logo/keycard-logo-hover.png'
import mercor from '../../img/logos/mercor-logo/mercor-logo.png'
import mercorHover from '../../img/logos/mercor-logo/mercor-logo-hover.png'
import meticulousai from '../../img/logos/meticulous-logo/meticulous-logo.png'
import meticulousaiHover from '../../img/logos/meticulous-logo/meticulous-logo-hover.png'
import n8n from '../../img/logos/n8n-logo/n8n-logo.png'
import n8nHover from '../../img/logos/n8n-logo/n8n-logo-hover.png'
import nexthopai from '../../img/logos/nexthop-ai-logo/nexthop-ai-logo.png'
import nexthopaiHover from '../../img/logos/nexthop-ai-logo/nexthop-ai-logo-hover.png'
import openrouter from '../../img/logos/openrouter-logo/openrouter-logo.png'
import openrouterHover from '../../img/logos/openrouter-logo/openrouter-logo-hover.png'
import parallelwebsystems from '../../img/logos/parallel-logo/parallel-logo.png'
import parallelwebsystemsHover from '../../img/logos/parallel-logo/parallel-logo-hover.png'
import pushsecurity from '../../img/logos/push-security-logo/push-security-logo.png'
import pushsecurityHover from '../../img/logos/push-security-logo/push-security-logo-hover.png'
import raindropai from '../../img/logos/raindrop-logo/raindrop-logo.png'
import raindropaiHover from '../../img/logos/raindrop-logo/raindrop-logo-hover.png'
import reactor from '../../img/logos/reactor-logo/reactor-logo.png'
import reactorHover from '../../img/logos/reactor-logo/reactor-logo-hover.png'
import reducto from '../../img/logos/reducto-logo/reducto-logo.png'
import reductoHover from '../../img/logos/reducto-logo/reducto-logo-hover.png'
import revel from '../../img/logos/revel-logo/revel-logo.png'
import revelHover from '../../img/logos/revel-logo/revel-logo-hover.png'
import herald from '../../img/logos/herald-logo/herald-logo.png'
import heraldHover from '../../img/logos/herald-logo/herald-logo-hover.png'
import sailresearch from '../../img/logos/sail-logo/sail-logo.png'
import sailresearchHover from '../../img/logos/sail-logo/sail-logo-hover.png'
import scaleops from '../../img/logos/scale-ops-logo/scale-ops-logo.png'
import scaleopsHover from '../../img/logos/scale-ops-logo/scale-ops-logo-hover.png'
import serval from '../../img/logos/serval-logo/serval-logo.png'
import servalHover from '../../img/logos/serval-logo/serval-logo-hover.png'
import sphinxai from '../../img/logos/sphinx-logo/sphinx-logo.png'
import sphinxaiHover from '../../img/logos/sphinx-logo/sphinx-logo-hover.png'
import surge from '../../img/logos/surge-logo/surge-logo.png'
import surgeHover from '../../img/logos/surge-logo/surge-logo-hover.png'
import tenzai from '../../img/logos/tenzai-logo/tenzai-logo.png'
import tenzaiHover from '../../img/logos/tenzai-logo/tenzai-logo-hover.png'
import trajectory from '../../img/logos/trajectory-logo/trajectory-logo.png'
import trajectoryHover from '../../img/logos/trajectory-logo/trajectory-logo-hover.png'
import wisdomai from '../../img/logos/wisdomai-logo/wisdomai-logo.png'
import wisdomaiHover from '../../img/logos/wisdomai-logo/wisdomai-logo-hover.png'
import zednew from '../../img/logos/zed-logo/zed-logo.png'
import zednewHover from '../../img/logos/zed-logo/zed-logo-hover.png'
import exa from '../../img/logos/exa-logo/exa-logo.png'
import exaHover from '../../img/logos/exa-logo/exa-logo-hover.png'
import factory from '../../img/logos/factory-logo/factory-logo.png'
import factoryHover from '../../img/logos/factory-logo/factory-logo-hover.png'
import primeintellect from '../../img/logos/prime-intellect-logo/prime-intellect-logo.png'
import primeintellectHover from '../../img/logos/prime-intellect-logo/prime-intellect-logo-hover.png'

import sponsorCooley from '../../img/infrared/sponsors/cooley-logo.png'
import sponsorCooleyHover from '../../img/infrared/sponsors/cooley-logo-hover.png'
import sponsorGcp from '../../img/infrared/sponsors/gcp-logo.png'
import sponsorGcpHover from '../../img/infrared/sponsors/gcp-logo-hover.png'
import sponsorJpm from '../../img/infrared/sponsors/jpm-logo.png'
import sponsorJpmHover from '../../img/infrared/sponsors/jpm-logo-hover.png'
import sponsorTwilio from '../../img/infrared/sponsors/twilio-logo.png'
import sponsorTwilioHover from '../../img/infrared/sponsors/twilio-logo-hover.png'

import * as styles from './infra.module.css'
import linkStyle from '../../styles/components/links.module.css'
import Icon from '../../components/icons'

export const query = graphql`
  query CloudInfraredQuery {
    page: sanityPage(title: { eq: "Infrared 100" }) {
      title
      _rawBody
      metaTitle
      metaDescription
      metaKeywords
      metaImage {
        asset {
          _id
          url
        }
      }
    }
    reports: sanityPage(title: { eq: "Infrared Report" }) {
      infrared {
        sixthSection {
          documents {
            year
            googleDriveLink
          }
        }
      }
    }
    infrared2026: allGoogle2026InfraRed100TableSheet {
      nodes {
        company
        logoRef: logo
        url
        stage
        location
        totalRaisedToDate
        subcategory
        portfolio
      }
    }
    infrared2025: allGoogle2025InfraRed100TableSheet {
      nodes {
        company
        logoRef: logo
        url
        stage
        location
        totalRaisedToDate
        subcategory
        portfolio
      }
    }
    infrared2024: allGoogle2024InfraRed100TableSheet {
      nodes {
        company
        logoRef: logo
        url
        stage
        location
        totalRaisedToDate
        subcategory
        portfolio
      }
    }
    infrared2023: allGoogleInfraRed100TableSheet {
      nodes {
        company
        logoRef: logo
        url
        stage
        location
        totalFunding
        subcategory
        portfolio
      }
    }
  }
`

const CloudInfraPage = props => {
  const { data, errors } = props
  const logos = {
    onepassword: onepassword,
    onepasswordHover: onepasswordHover,
    abnormal: abnormal,
    abnormalHover: abnormalHover,
    airplane: airplane,
    airplaneHover: airplaneHover,
    appomni: appomni,
    appomniHover: appomniHover,
    arcticwolf: arcticwolf,
    arcticwolfHover: arcticwolfHover,
    assemblyai: assemblyai,
    assemblyaiHover: assemblyaiHover,
    atlan: atlan,
    atlanHover: atlanHover,
    autogpt: autogpt,
    autogptHover: autogptHover,
    axonius: axonius,
    axoniusHover: axoniusHover,
    buildbuddy: buildbuddy,
    buildbuddyHover: buildbuddyHover,
    chainguard: chainguard,
    chainguardHover: chainguardHover,
    chromatic: chromatic,
    chromaticHover: chromaticHover,
    chronosphere: chronosphere,
    chronosphereHover: chronosphereHover,
    clickhouse: clickhouse,
    clickhouseHover: clickhouseHover,
    cockroachlabs: cockroachlabs,
    cockroachlabsHover: cockroachlabsHover,
    collibra: collibra,
    collibraHover: collibraHover,
    conductorone: conductorone,
    conductoroneHover: conductoroneHover,
    cortex: cortex,
    cortexHover: cortexHover,
    cribl: cribl,
    criblHover: criblHover,
    cyberhaven: cyberhaven,
    cyberhavenHover: cyberhavenHover,
    cyera: cyera,
    cyeraHover: cyeraHover,
    dagger: dagger,
    daggerHover: daggerHover,
    databricks: databricks,
    databricksHover: databricksHover,
    dataiku: dataiku,
    dataikuHover: dataikuHover,
    dbt: dbtlabs,
    dbtHover: dbtlabsHover,
    dbtlabs: dbtlabs,
    dbtlabsHover: dbtlabsHover,
    deno: deno,
    denoHover: denoHover,
    descope: descope,
    descopeHover: descopeHover,
    docker: docker,
    dockerHover: dockerHover,
    doppler: doppler,
    dopplerHover: dopplerHover,
    dragonflydb: dragonflydb,
    dragonflydbHover: dragonflydbHover,
    drata: drata,
    drataHover: drataHover,
    dremio: dremio,
    dremioHover: dremioHover,
    fireblocks: fireblocks,
    fireblocksHover: fireblocksHover,
    fivetran: fivetran,
    fivetranHover: fivetranHover,
    flyio: flyio,
    flyioHover: flyioHover,
    glean: glean,
    gleanHover: gleanHover,
    grafanalabs: grafanalabs,
    grafanalabsHover: grafanalabsHover,
    harness: harness,
    harnessHover: harnessHover,
    hex: hex,
    hexHover: hexHover,
    hightouch: hightouch,
    hightouchHover: hightouchHover,
    huggingface: huggingface,
    huggingfaceHover: huggingfaceHover,
    humansignal: humansignal,
    humansignalHover: humansignalHover,
    incidentio: incidentio,
    incidentioHover: incidentioHover,
    island: island,
    islandHover: islandHover,
    isovalent: isovalent,
    isovalentHover: isovalentHover,
    jellyfish: jellyfish,
    jellyfishHover: jellyfishHover,
    kubecost: kubecost,
    kubecostHover: kubecostHover,
    langchain: langchain,
    langchainHover: langchainHover,
    launchdarkly: launchdarkly,
    launchdarklyHover: launchdarklyHover,
    linear: linear,
    linearHover: linearHover,
    livekit: livekit,
    livekitHover: livekitHover,
    lumos: lumos,
    lumosHover: lumosHover,
    materialize: materialize,
    materializeHover: materializeHover,
    metronome: metronome,
    metronomeHover: metronomeHover,
    minio: minio,
    minioHover: minioHover,
    modal: modal,
    modalHover: modalHover,
    montecarlo: montecarlo,
    montecarloHover: montecarloHover,
    motherduck: motherduck,
    motherduckHover: motherduckHover,
    neon: neon,
    neonHover: neonHover,
    omni: omni,
    omniHover: omniHover,
    openai: openai,
    openaiHover: openaiHover,
    orcasecurity: orcasecurity,
    orcasecurityHover: orcasecurityHover,
    oven: oven,
    ovenHover: ovenHover,
    pinecone: pinecone,
    pineconeHover: pineconeHover,
    planetscale: planetscale,
    planetscaleHover: planetscaleHover,
    postman: postman,
    postmanHover: postmanHover,
    projectdiscoveryio: projectdiscoveryio,
    projectdiscoveryioHover: projectdiscoveryioHover,
    pulumi: pulumi,
    pulumiHover: pulumiHover,
    railway: railway,
    railwayHover: railwayHover,
    redis: redis,
    redisHover: redisHover,
    redpandadata: redpandadata,
    redpandadataHover: redpandadataHover,
    replicate: replicate,
    replicateHover: replicateHover,
    replicated: replicated,
    replicatedHover: replicatedHover,
    replit: replit,
    replitHover: replitHover,
    retool: retool,
    retoolHover: retoolHover,
    'reflection ai': reflection,
    'reflection aiHover': reflectionHover,
    runzero: runzero,
    runzeroHover: runzeroHover,
    'scale ai': scaleai,
    'scale aiHover': scaleaiHover,
    scaleai: scaleai,
    scaleaiHover: scaleaiHover,
    semgrep: semgrep,
    semgrepHover: semgrepHover,
    sigma: sigma,
    sigmaHover: sigmaHover,
    singlestore: singlestore,
    singlestoreHover: singlestoreHover,
    snyk: snyk,
    snykHover: snykHover,
    soloio: soloio,
    soloioHover: soloioHover,
    sourcegraph: sourcegraph,
    sourcegraphHover: sourcegraphHover,
    starburst: starburst,
    starburstHover: starburstHover,
    startree: startree,
    startreeHover: startreeHover,
    stripe: stripe,
    stripeHover: stripeHover,
    supabase: supabase,
    supabaseHover: supabaseHover,
    synthesia: synthesia,
    synthesiaHover: synthesiaHover,
    tabular: tabular,
    tabularHover: tabularHover,
    tackleio: tackleio,
    tackleioHover: tackleioHover,
    tailscale: tailscale,
    tailscaleHover: tailscaleHover,
    temporal: temporal,
    temporalHover: temporalHover,
    timescale: timescale,
    timescaleHover: timescaleHover,
    tines: tines,
    tinesHover: tinesHover,
    vercel: vercel,
    vercelHover: vercelHover,
    weaviate: weaviate,
    weaviateHover: weaviateHover,
    weightsbiases: weightsbiases,
    weightsbiasesHover: weightsbiasesHover,
    wiz: wiz,
    wizHover: wizHover,
    workato: workato,
    workatoHover: workatoHover,
    zesty: zesty,
    zestyHover: zestyHover,
    anthropic: anthropic,
    anthropicHover: anthropicHover,
    baseten: baseten,
    basetenHover: basetenHover,
    bitdrift: bitdrift,
    bitdriftHover: bitdriftHover,
    braintrust: braintrust,
    braintrustHover: braintrustHover,
    braintrustdata: braintrust,
    braintrustdataHover: braintrustHover,
    bolt: bolt,
    boltHover: boltHover,
    cerby: cerby,
    cerbyHover: cerbyHover,
    clerk: clerk,
    clerkHover: clerkHover,
    codium: codium,
    codiumHover: codiumHover,
    cognition: cognition,
    cognitionHover: cognitionHover,
    coreweave: coreweave,
    coreweaveHover: coreweaveHover,
    elevenlabs: iielevenlabs,
    elevenlabsHover: iielevenlabsHover,
    flutterflow: flutterflow,
    flutterflowHover: flutterflowHover,
    lancedb: lancedb,
    lancedbHover: lancedbHover,
    llamaindex: llamaindex,
    llamaindexHover: llamaindexHover,
    localstack: localstack,
    localstackHover: localstackHover,
    magic: magic,
    magicHover: magicHover,
    mistral: mistralai,
    mistralHover: mistralaiHover,
    modular: modular,
    modularHover: modularHover,
    momento: momento,
    momentoHover: momentoHover,
    nagomisecurity: nagomi,
    nagomisecurityHover: nagomiHover,
    normai: normai,
    normaiHover: normaiHover,
    oasis: oasis,
    oasisHover: oasisHover,
    ollama: ollama,
    ollamaHover: ollamaHover,
    patronus: patronusai,
    patronusHover: patronusaiHover,
    'poolside ': poolside,
    'poolside Hover': poolsideHover,
    'reflex ': reflex,
    'reflex Hover': reflexHover,
    resend: resend,
    resendHover: resendHover,
    'restate ': restate,
    'restate Hover': restateHover,
    sublimesecurity: sublimesecurity,
    sublimesecurityHover: sublimesecurityHover,
    surrealdb: surrealdb,
    surrealdbHover: surrealdbHover,
    tessell: tessell,
    tessellHover: tessellHover,
    tigerbeetle: tigerbeetle,
    tigerbeetleHover: tigerbeetleHover,
    'togetherai ': togetherai,
    'togetherai Hover': togetheraiHover,
    upwind: upwind,
    upwindHover: upwindHover,
    vantage: vantage,
    vantageHover: vantageHover,
    vastdata: vast,
    vastdataHover: vastHover,
    warpstream: warpstream,
    warpstreamHover: warpstreamHover,
    zed: zednew,
    zedHover: zednewHover,
    straiker: straiker,
    straikerHover: straikerHover,
    render: render,
    renderHover: renderHover,
    halcyon: halcyon,
    halcyonHover: halcyonHover,
    scale: scale,
    scaleHover: scaleHover,
    goodfire: goodfire,
    goodfireHover: goodfireHover,
    xbow: xbow,
    xbowHover: xbowHover,
    cursor: cursor,
    cursorHover: cursorHover,
    gitpod: gitpod,
    gitpodHover: gitpodHover,
    'pointfive.co': pointfive,
    'pointfive.coHover': pointfiveHover,
    cohesity: cohesity,
    cohesityHover: cohesityHover,
    prophet: prophet,
    prophetHover: prophetHover,
    '7ai': ai,
    '7aiHover': aiHover,
    stackblitz: stackblitz,
    stackblitzHover: stackblitzHover,
    flox: flox,
    floxHover: floxHover,
    browserbase: browserbase,
    browserbaseHover: browserbaseHover,
    'fal ai': fal,
    'fal aiHover': falHover,
    traversal: traversal,
    traversalHover: traversalHover,
    grofanalabs: grofanalabs,
    grofanalabsHover: grofanalabsHover,
    'resolve ai': resolveai,
    'resolve aiHover': resolveaiHover,
    'astrix security': astrix,
    'astrix securityHover': astrixHover,
    dragonfly: dragonfly,
    dragonflyHover: dragonflyHover,
    antithesis: antithesis,
    antithesisHover: antithesisHover,
    unsloth: unsloth,
    unslothHover: unslothHover,
    coderabbit: coderabbit,
    coderabbitHover: coderabbitHover,
    'legion security': legion,
    'legion securityHover': legionHover,
    'adaptive ml': adaptive,
    'adaptive mlHover': adaptiveHover,
    port: port,
    portHover: portHover,
    spiraldb: spiral,
    spiraldbHover: spiralHover,
    vapi: vapi,
    vapiHover: vapiHover,
    'qa wolf': qawold,
    'qa wolfHover': qawoldHover,
    turbopuffer: turbopuffer,
    turbopufferHover: turbopufferHover,
    licvekit: licvekit,
    licvekitHover: licvekitHover,
    bitwarden: bitwarden,
    bitwardenHover: bitwardenHover,
    'fireworks ai': fireworksai,
    'fireworks aiHover': fireworksaiHover,
    mimic: mimic,
    mimicHover: mimicHover,
    'pydantic dev': pydantic,
    'pydantic devHover': pydanticHover,
    lovable: lovable,
    lovableHover: lovableHover,
    outtake: outtakeai,
    outtakeHover: outtakeaiHover,
    composio: composio,
    composioHover: composioHover,
    unstructured: unstructured,
    unstructuredHover: unstructuredHover,
    'vega security': vega,
    'vega securityHover': vegaHover,
    statsig: statsig,
    statsigHover: statsigHover,
    windsurf: windsurf,
    windsurfHover: windsurfHover,
    stainless: stainless,
    stainlessHover: stainlessHover,
    'applied-compute': appliedcompute,
    'applied-computeHover': appliedcomputeHover,
    armadin: armadin,
    armadinHover: armadinHover,
    blacksmith: blacksmith,
    blacksmithHover: blacksmithHover,
    'code-storage': codestorage,
    'code-storageHover': codestorageHover,
    codemetal: codemetal,
    codemetalHover: codemetalHover,
    coder: coder,
    coderHover: coderHover,
    'cogent-security': cogentsecurity,
    'cogent-securityHover': cogentsecurityHover,
    dash0: dash0,
    dash0Hover: dash0Hover,
    'david-ai': davidai,
    'david-aiHover': davidaiHover,
    daytona: daytona,
    daytonaHover: daytonaHover,
    deeptune: deeptune,
    deeptuneHover: deeptuneHover,
    depthfirst: depthfirst,
    depthfirstHover: depthfirstHover,
    dux: dux,
    duxHover: duxHover,
    e2b: e2b,
    e2bHover: e2bHover,
    emergent: emergent,
    emergentHover: emergentHover,
    eon: eon,
    eonHover: eonHover,
    ersc: ersc,
    erscHover: erscHover,
    fable: fable,
    fableHover: fableHover,
    fleet: fleet,
    fleetHover: fleetHover,
    gambit: gambit,
    gambitHover: gambitHover,
    'gimlet-labs': gimletlabs,
    'gimlet-labsHover': gimletlabsHover,
    glow: glow,
    glowHover: glowHover,
    imper: imper,
    imperHover: imperHover,
    inferact: inferact,
    inferactHover: inferactHover,
    'irregular-labs': irregularlabs,
    'irregular-labsHover': irregularlabsHover,
    jetstream: jetstream,
    jetstreamHover: jetstreamHover,
    'judgment-labs': judgmentlabs,
    'judgment-labsHover': judgmentlabsHover,
    keycard: keycard,
    keycardHover: keycardHover,
    mercor: mercor,
    mercorHover: mercorHover,
    'meticulous-ai': meticulousai,
    'meticulous-aiHover': meticulousaiHover,
    n8n: n8n,
    n8nHover: n8nHover,
    'nexthop-ai': nexthopai,
    'nexthop-aiHover': nexthopaiHover,
    openrouter: openrouter,
    openrouterHover: openrouterHover,
    'parallel-web-systems': parallelwebsystems,
    'parallel-web-systemsHover': parallelwebsystemsHover,
    'push-security': pushsecurity,
    'push-securityHover': pushsecurityHover,
    'raindrop-ai': raindropai,
    'raindrop-aiHover': raindropaiHover,
    reactor: reactor,
    reactorHover: reactorHover,
    reducto: reducto,
    reductoHover: reductoHover,
    revel: revel,
    revelHover: revelHover,
    runllm: herald,
    runllmHover: heraldHover,
    'sail-research': sailresearch,
    'sail-researchHover': sailresearchHover,
    scaleops: scaleops,
    scaleopsHover: scaleopsHover,
    serval: serval,
    servalHover: servalHover,
    'sphinx-ai': sphinxai,
    'sphinx-aiHover': sphinxaiHover,
    surge: surge,
    surgeHover: surgeHover,
    tenzai: tenzai,
    tenzaiHover: tenzaiHover,
    trajectory: trajectory,
    trajectoryHover: trajectoryHover,
    wisdomai: wisdomai,
    wisdomaiHover: wisdomaiHover,
    exa: exa,
    exaHover: exaHover,
    factory: factory,
    factoryHover: factoryHover,
    'prime-intellect': primeintellect,
    'prime-intellectHover': primeintellectHover,
    'arctic-wolf': arcticwolf,
    'arctic-wolfHover': arcticwolfHover,
    'cockroach-labs': cockroachlabs,
    'cockroach-labsHover': cockroachlabsHover,
    'dbt-labs': dbtlabs,
    'dbt-labsHover': dbtlabsHover,
    fal: fal,
    falHover: falHover,
    fireworks: fireworksai,
    fireworksHover: fireworksaiHover,
    'grafana-labs': grafanalabs,
    'grafana-labsHover': grafanalabsHover,
    legion: legion,
    legionHover: legionHover,
    'mistral-ai': mistralai,
    'mistral-aiHover': mistralaiHover,
    poolside: poolside,
    poolsideHover: poolsideHover,
    restate: restate,
    restateHover: restateHover,
    'sublime-security': sublimesecurity,
    'sublime-securityHover': sublimesecurityHover,
    'together-ai': togetherai,
    'together-aiHover': togetheraiHover,
    vast: vast,
    vastHover: vastHover,
    vega: vega,
    vegaHover: vegaHover
  }
  const smallLogoSlugs = new Set([
    'armadin',
    'codemetal',
    'cogent-security',
    'daytona',
    'deeptune',
    'eon',
    'exa',
    'fable',
    'imper',
    'mercor',
    'nexthop-ai',
    'openrouter',
    'parallel-web-systems',
    'raindrop-ai',
    'reactor',
    'revel',
    'runllm',
    'legion',
    'zed',
    'blacksmith',
    'braintrust',
    'cursor',
    'cyera',
    'dux',
    'emergent',
    'langchain',
    'lovable',
    'openai',
    'restate',
  ])

  const mediumLogoSlugs = new Set([
    'sublime-security',
    'applied-compute',
    'depthfirst',
    'wisdomai',
    'jetstream',
    'judgment-labs',
    'push-security',
    'turbopuffer',
    'trajectory',
    'factory',
    'inferact',
    'mistral-ai',
    'surge',
    'traversal',
    'irregular-labs',
    'baseten',
    'dash0',
    'david-ai',
    'e2b',
    'fal',
    'fleet',
    'gambit',
    'glean',
    'glow',
    'island',
    'livekit',
    'meticulous-ai',
    'n8n',
    'prime-intellect',
    'reducto',
    'sphinx-ai',
    'serval',
    'tenzai',
    'vega',
  ])

  const createLogo = (logoRef, company) => {
    const style = smallLogoSlugs.has(logoRef)
      ? { height: '24px' }
      : mediumLogoSlugs.has(logoRef)
      ? { height: '32px' }
      : {}
    return (
      <>
        <img src={logos[logoRef]} alt={company} className="default" style={style} />
        <img src={logos[`${logoRef}Hover`]} alt={company} className="hover" style={style} />
      </>
    )
  }

  const transformNodes = nodes =>
    nodes.map(c => ({
      ...c,
      logo: () => createLogo(c.logoRef, c.company) || null
    }))

  const default2026Nodes = transformNodes(data.infrared2026.nodes)
  const default2025Nodes = transformNodes(data.infrared2025.nodes)
  const default2024Nodes = transformNodes(data.infrared2024.nodes)
  const default2023Nodes = transformNodes(data.infrared2023.nodes)

  const [display2026Nodes, setDisplay2026Nodes] = useState(default2026Nodes)
  const [display2025Nodes, setDisplay2025Nodes] = useState(default2025Nodes)
  const [display2024Nodes, setDisplay2024Nodes] = useState(default2024Nodes)
  const [display2023Nodes, setDisplay2023OldNodes] = useState(default2023Nodes)
  const [activeFilter, setActiveFilter] = useState('')

  const headers = [
    {
      label: 'Company',
      data: 'logo',
      format: 'component',
      orderby: true
    },
    {
      label: 'Stage',
      data: 'stage',
      orderby: true
    },
    {
      label: 'Location',
      data: 'location'
    },
    {
      label: 'Total Funding',
      data: 'totalFunding',
      orderby: true
    },
    {
      label: 'Total Raised to Date',
      data: 'totalRaisedToDate',
      orderby: true
    },
    {
      label: 'Subcategory',
      data: 'subcategory'
    }
  ]

  const handleFilterClick = stage => {
    setActiveFilter(stage)

    const shouldFilter = stage !== ''

    const datasets = [
      { source: default2026Nodes, setter: setDisplay2026Nodes },
      { source: default2025Nodes, setter: setDisplay2025Nodes },
      { source: default2024Nodes, setter: setDisplay2024Nodes },
      { source: default2023Nodes, setter: setDisplay2023OldNodes }
    ]

    datasets.forEach(({ source, setter }) => {
      setter(shouldFilter ? source.filter(n => n.stage === stage) : source)
    })
  }

  const report2026 = data.reports?.infrared?.sixthSection?.documents.find(
    report => report.year === '2026'
  )

  function trackDownload(report) {
    if (!report) return
    if (typeof gtag !== 'undefined') {
      gtag('event', `download_the_report_${report}`, {
        component: 'button'
      })
    }
  }

  function convertToDownloadLink(viewLink) {
    if (!viewLink) return null
    const fileIdMatch = viewLink.match(/\/d\/([a-zA-Z0-9_-]+)\//)
    if (fileIdMatch && fileIdMatch[1]) {
      const fileId = fileIdMatch[1]
      return `https://drive.google.com/uc?export=download&id=${fileId}`
    } else {
      return viewLink
    }
  }

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  return (
    <Layout page="cloudInfrared" palette="red" hideContactBar version="1">
      <SEO
        title={data?.page?.metaTitle || data?.page?.title}
        description={data?.page?.metaDescription}
        keywords={data?.page?.metaKeywords ? data?.page?.metaKeywords.split(',') : []}
        imageFB={data?.page?.metaImage.asset.url}
      />

      <CloudIndexNav black current="infrared" />
      <Container class={styles.container}>
        <div className={styles.infra100header}>
          <div>
            <img src={infraLogo} alt="InfraRed" />
          </div>

          <div>
            InfraRed 100 honors 100 transformative companies in cloud infrastructure. These
            trailblazers have set new benchmarks for reliability, scalability, security, and
            innovation, enabling businesses to thrive in a cloud era and ushering a new paradigm of
            building applications. Every year, we plan to update this list and honor the latest
            companies that have excelled in building next generation cloud infrastructure solutions.
          </div>
        </div>

        <div className={styles.filterBy}>
          <div className={styles.label}>Filters</div>
          <div className={styles.filterWrapper}>
            <div>
              <span
                className={`${activeFilter === '' ? styles.active : ''}`}
                onClick={() => handleFilterClick('')}
              >
                All stages
              </span>
              {[...new Set(default2026Nodes.map(n => n.stage).filter(n => n))]
                .reverse()
                .map((s, sI) => (
                  <span
                    key={sI}
                    className={`${activeFilter === s ? styles.active : ''}`}
                    onClick={() => handleFilterClick(s)}
                  >
                    {s}
                  </span>
                ))}
            </div>

            {report2026 && (
              <div style={{ display: 'flex' }}>
                <a
                  className={`${linkStyle.linkArrow} ${styles.downloadReportBtn} ${linkStyle.white}`}
                  href={convertToDownloadLink(report2026.googleDriveLink)}
                  onClick={() => trackDownload('2026')}
                >
                  Download the {report2026.year} report
                  <span>
                    <div className={linkStyle.iconCircle} />
                    <div className={linkStyle.icon}>
                      <Icon symbol="newsArrowIcon" color="currentColor" />
                    </div>
                    <div className={linkStyle.iconSecondary}>
                      <Icon symbol="newsArrowIcon" color="currentColor" />
                    </div>
                  </span>
                </a>
              </div>
            )}
          </div>
        </div>

        <CloudIndexTable
          headers={headers}
          data={display2026Nodes}
          date="2026"
          inverse
          accentColor="var(--color-red)"
        />

        <Accordion title="InfraRed 100" marker="2025">
          <CloudIndexTable
            headers={headers}
            data={display2025Nodes}
            date="2025"
            inverse
            accentColor="var(--color-red)"
          />
        </Accordion>

        <Accordion title="InfraRed 100" marker="2024">
          <CloudIndexTable
            headers={headers}
            data={display2024Nodes}
            date="2024"
            inverse
            accentColor="var(--color-red)"
          />
        </Accordion>

        <Accordion title="InfraRed 100" marker="2023">
          <CloudIndexTable
            headers={headers}
            data={display2023Nodes}
            date="2023"
            inverse
            accentColor="var(--color-red)"
          />
        </Accordion>

        <span className={`${styles.footnote} ${styles.inverse}`}>
          Early stage defined as Seed and Series A startups. Mid stage defined as startups that have
          raised at least a Series B with &lt;$200M total funding. Late stage defined as startups
          that have raised ≥$200m total funding. Total Funding Amounts from Pitchbook as of July
          14th, 2023 and may include equity, debt, secondary or other financing transactions. For
          certain Redpoint portfolio companies (indicated by an asterisk), if Redpoint has access to
          additional information, a different Total Funding Amount may be listed. Redpoint selects
          the InfraRed 100 based on proprietary criteria, and certain companies selected (as
          indicated with an asterisk) are Redpoint portfolio companies.
        </span>
      </Container>

      <section className={styles.participatingPartnersSection}>
        <div className={styles.participatingPartnersContainer}>
          <h2 className={styles.participatingPartnersTitle}>InfraRed 2026 Sponsors</h2>
          <div className={styles.participatingPartnersLogos}>
            <div className={styles.partnerLogo}>
              <a href="https://www.cooley.com/" target="_blank" rel="noopener noreferrer">
                <img src={sponsorCooley} alt="Cooley" className={styles.sponsorDefault} />
                <img src={sponsorCooleyHover} alt="" aria-hidden="true" className={styles.sponsorHover} />
              </a>
            </div>
            <div className={styles.partnerLogo}>
              <a href="https://cloud.google.com/" target="_blank" rel="noopener noreferrer">
                <img src={sponsorGcp} alt="Google Cloud" className={styles.sponsorDefault} style={{ maxWidth: '164px' }} />
                <img src={sponsorGcpHover} alt="" aria-hidden="true" className={styles.sponsorHover} style={{ maxWidth: '164px' }} />
              </a>
            </div>
            <div className={styles.partnerLogo}>
              <a href="https://www.jpmorgan.com/" target="_blank" rel="noopener noreferrer">
                <img src={sponsorJpm} alt="JP Morgan" className={styles.sponsorDefault} />
                <img src={sponsorJpmHover} alt="" aria-hidden="true" className={styles.sponsorHover} />
              </a>
            </div>
            <div className={styles.partnerLogo}>
              <a href="https://www.twilio.com/" target="_blank" rel="noopener noreferrer">
                <img src={sponsorTwilio} alt="Twilio" className={styles.sponsorDefault} />
                <img src={sponsorTwilioHover} alt="" aria-hidden="true" className={styles.sponsorHover} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default CloudInfraPage
